import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

type ParallaxWrapperProps = {
  children: React.ReactNode;
};

/**
 * Wrapper component for React Scroll Parallax
 * Provides parallax context to child components
 */
export const ParallaxWrapper: React.FC<ParallaxWrapperProps> = ({ children }) => {
  return (
    <ParallaxProvider>
      {children}
    </ParallaxProvider>
  );
};
